var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInquiryWatch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.23-800h101.54H429.23Zm0 640H530.77 429.23Zm-30.77 40-44.77-157.38q-50.31-29.54-82-83.47Q240-414.77 240-480t31.69-119.15q31.69-53.93 82-83.47L398.46-840h163.08l44.77 157.38q50.31 29.54 82 83.47Q720-545.23 720-480t-31.69 119.15q-31.69 53.93-82 83.47L561.54-120H398.46ZM621.5-338.5Q680-397 680-480t-58.5-141.5Q563-680 480-680t-141.5 58.5Q280-563 280-480t58.5 141.5Q397-280 480-280t141.5-58.5ZM402.46-706.92q20.77-6.54 39.66-9.93 18.88-3.38 37.88-3.38 19 0 37.88 3.38 18.89 3.39 39.66 9.93L530.77-800H429.23l-26.77 93.08ZM429.23-160h101.54l26.77-93.08q-20.77 6.54-39.66 9.43-18.88 2.88-37.88 2.88-19 0-37.88-2.88-18.89-2.89-39.66-9.43L429.23-160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiryWatch);
export default __webpack_public_path__ + "static/media/InquiryWatch.aa634b76aa2c582638aec096a38dc3c9.svg";
export { ForwardRef as ReactComponent };